import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";

export default function SupplyProductsManager() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ category: "Boîtes" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/supply/products").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const add = async () => {
    if (!form.name || !form.price) { toast.error("Nom et prix requis"); return; }
    setBusy(true);
    try { await api.post("/admin/supply/products", { name: form.name, category: form.category || "Autres", price: parseFloat(form.price), unit: form.unit || "" }); toast.success("Produit ajouté"); setForm({ category: "Boîtes" }); load(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  const del = async (id) => { try { await api.delete(`/admin/supply/products/${id}`); load(); } catch (e) { toast.error(apiErr(e)); } };

  const cats = [...new Set(items.map((i) => i.category))];
  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="card-cocarde p-5 h-fit">
        <h3 className="font-display text-xl cc-navy mb-1">Vendre aux pizzerias</h3>
        <p className="text-slate-500 text-xs mb-3">Boîtes pizza, ingrédients, PLV et le Kit Pizza Cocarde.</p>
        <div className="space-y-3">
          <input data-testid="sp-name" placeholder="Nom (ex: Boîtes « Le Candidat » x50)" value={form.name || ""} onChange={set("name")} className="w-full border border-slate-300 rounded-xl px-4 py-2.5 outline-none focus:border-cc-red" />
          <input data-testid="sp-cat" placeholder="Catégorie" value={form.category || ""} onChange={set("category")} className="w-full border border-slate-300 rounded-xl px-4 py-2.5 outline-none focus:border-cc-red" />
          <div className="flex gap-2">
            <input data-testid="sp-price" type="number" step="0.10" placeholder="Prix €" value={form.price || ""} onChange={set("price")} className="w-1/2 border border-slate-300 rounded-xl px-4 py-2.5 outline-none focus:border-cc-red" />
            <input data-testid="sp-unit" placeholder="Unité" value={form.unit || ""} onChange={set("unit")} className="w-1/2 border border-slate-300 rounded-xl px-4 py-2.5 outline-none focus:border-cc-red" />
          </div>
          <button data-testid="sp-add" onClick={add} disabled={busy} className="btn-cocarde w-full inline-flex items-center justify-center gap-2 disabled:opacity-60"><Plus size={16} /> Ajouter</button>
        </div>
      </div>
      <div className="lg:col-span-2 space-y-6">
        {cats.map((cat) => (
          <div key={cat}>
            <h4 className="font-display text-lg cc-navy mb-2">{cat}</h4>
            <div className="grid sm:grid-cols-2 gap-3">
              {items.filter((i) => i.category === cat).map((p) => (
                <div key={p.id} data-testid={`sp-item-${p.id}`} className="card-cocarde p-4 flex items-center justify-between">
                  <div><p className="font-bold cc-navy">{p.name}</p><p className="text-slate-500 text-sm">{p.price} € · {p.unit}</p></div>
                  <button data-testid={`sp-del-${p.id}`} onClick={() => del(p.id)} className="text-slate-400 hover:text-cc-red p-2"><Trash2 size={18} /></button>
                </div>
              ))}
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-slate-400">Aucun produit.</p>}
      </div>
    </div>
  );
}
